<template>
  <div class="head-cate">
    <ul @scroll="scroll">
      <li v-for="item of list " :class="item.action ? 'action' : ''" :key="item.cat_id"
        @click="selectedCate(item.cat_id)">
        <img :src="item.cat_pic" />
        <p>{{ item.cat_name }}</p>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => []
    },
    sId: {
      type: Number,
    }
  },
  data () {
    return {
      cateList: this.list || []
    }
  },
  // computed: {
    
  //   resetCateList () {
  //     let list = []
  //     this.cateList.forEach((elem, index) => {
  //       elem.action = false
  //       if (sId == 0) {
  //         index == 0 ? elem.action = true : ''
  //       } else {
  //         elem.cat_id == sId ? elem.action = true : ''
  //       }
  //       list.push()
  //     });
  //     return list
  //   }
  // },
  
  methods: {
    scroll (e) {
      e.target.getBoundingClientRect()
      console.log(e.target.getBoundingClientRect());
    },
    selectedCate (id) {
      this.cateList.map((elem, index) => {

      })
      this.$emit('selectedId', id)
    }
  },
  watch: {
    list (value) {
      value.forEach((elem, index) => {
        elem.action = false
        if (this.sId == 0 && index == 0) {
          elem.action = true
        }
      });
      this.cateList = value
    }
  }
}
</script>
<style lang="scss" scoped>
.head-cate {
  background: #fff;
  margin: 0.1rem 0;
  padding: 0.1rem 0;

  ul {
    display: flex;
    width: 100%;
    overflow-x: scroll;
    justify-content: space-between;

    li {
      width: 2rem;
      flex: 1;
      text-align: center;
      margin: 0 0.1rem;

      p {
        margin: 0.1rem 0;
        font-size: 0.2rem;
      }

      img {
        width: 1rem;
        height: 1rem;
      }
    }
  }
}

.action{
  background: #5a9dff;
  p {
  
  }
}
</style>
